import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar";
import { billingSettingsQueries } from "~/modules/billing/api/billingSettings/billingSettingsQueries.ts";
import type { BillingSettings } from "~/modules/billing/api/billingSettings/billingSettingsTypes.ts";
import UpdateProjectBillingSettingsForm
	from "~/modules/project/components/ProjectDetailsView/components/ProjectBillingSectionTabContent/components/ProjectBillingSettingsTabContent/components/UpdateProjectBillingSettingsSidebar/UpdateProjectBillingSettingsForm.tsx";

type Props = {
	isOpen: boolean;
	onClose: () => void;
	clientId: string;
	projectBillingSettings?: BillingSettings
};

const UpdateProjectBillingSettingsSidebar = ({
	clientId,
	isOpen,
	onClose,
	projectBillingSettings,
}: Props) => {

	const queryClient = useQueryClient();
	const handleSuccess = useCallback(async () => {
		if (!projectBillingSettings) return;
		await queryClient.refetchQueries({ queryKey: billingSettingsQueries.byProject(projectBillingSettings.ownerId).queryKey });
		onClose();
	}, [onClose, projectBillingSettings, queryClient]);

	if (!isOpen || !projectBillingSettings) {
		return null;
	}

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={onClose}>
			{isOpen && projectBillingSettings &&
				<UpdateProjectBillingSettingsForm billingSettings={projectBillingSettings}
												  clientId={clientId}
												  onCancel={onClose}
												  onSuccess={handleSuccess} />}
		</Sidebar>
	);
};

export default UpdateProjectBillingSettingsSidebar;
